import { render } from "./TabulatorSummary.vue?vue&type=template&id=20696e66"
import script from "./TabulatorSummary.vue?vue&type=script&lang=js"
export * from "./TabulatorSummary.vue?vue&type=script&lang=js"

import "./TabulatorSummary.vue?vue&type=style&index=0&id=20696e66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__